/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
export class Company {
  id!: number;
  name!: string;
  status!: string;
}

export class Region {
  id!: number;
  name!: string; // Region Name
  code!: string; // Region Abbrevation
  currency!: string;
}

export class Volumes {}

export class DirectVolumes {
  id!: string;
  volumes: Volumes = new Volumes();
}

export class GroupVolumes {
  id!: string;
  volumes: Volumes = new Volumes();
}

export class GenerationVolumes {
  id!: string;
  volumes: Volumes = new Volumes();
}
export class LeaderVolumes {
  id!: string;
  volumes: Volumes = new Volumes();
}
export class SponsorVolumes {
  id!: string;
  volumes: Volumes = new Volumes();
}

export class CumulativeVolumes {
  id!: string;
  volumes: Volumes = new Volumes();
}

export class Title {
  id!: number;
  name!: string;
  rank!: number;
}

export class Sponsor {
  id!: number;
  clientId!: string;
}

export class Enroller {
  id!: number;
  clientId!: string;
}

export class TopLegParticipant {
  id!: number;
  clientId!: string;
}

export class ParticipantStatus {
  id!: number;
  name!: string;
}

export class Address {
  addressLine1!: string;
  addressLine2!: string;
  city!: string;
  county!: string;
  state!: string;
  country!: string;
  postalCode!: string;
}

export class Position {
  directVolumes!: string;
  groupVolumes!: string;
  leaderVolumes!: string;
  sponsorVolumes!: string;
  businessLeader!: boolean;
}

export class Participant {
  id!: number;
  memberId!: any;
  firstName!: string;
  middleName!: string;
  lastName!: string;
  email!: string;
  gender!: string;
  titleId!: number;
  rank!: any;
  titleName!: string;
  clientId!: string;
  sponsorId!: string;
  enrollerId!: string;
  regionCode!: string;
  regionName!: string;
  companyId!: number;
  name!: string;
  businessLeader!: string;
  directVolume!: string;
  groupVolume!: string;
  leaderVolume!: string;
  sponsorVolume!: string;
  cumulativeVolume!: string;
  planId!: string;
  source: any;
  mobileNumber!: number;
  phone!: number;
  teamLeaderId!: string;
  currency!: string;
  contractStartDate: any;
  branchManagerId!: string;
  teamId!: string;
  branchId!: string;
  regionId!: string;
  areaId!: string;
  earnProg: any;
  earningProgramType: any;
  divisionId!: string;

  addressLine1!: string;
  addressLine2!: string;
  addressLine3?: string;
  city!: string;
  county!: string;
  state!: string;
  country!: string;
  postalCode!: string;

  status: ParticipantStatus = new ParticipantStatus();
  address: Address = new Address();
  sponsor: Sponsor = new Sponsor();
  enroller: Enroller = new Enroller();
  region: Region = new Region();
  company: Company = new Company();
  joiningTitle: Title = new Title();
  directVolumes?: DirectVolumes = new DirectVolumes();
  groupVolumes?: GroupVolumes = new GroupVolumes();
  generationVolumes?: GenerationVolumes = new GenerationVolumes();
  leaderVolumes?: LeaderVolumes = new LeaderVolumes();
  sponsorVolumes?: SponsorVolumes = new SponsorVolumes();
  cumulativeVolumes?: CumulativeVolumes = new CumulativeVolumes();
  topLegParticipant?: TopLegParticipant = new TopLegParticipant();
  position: Position = new Position();
}
